<template>
  <div>
    <PageHeader :items="items" />
    <b-tabs content-class="mt-2">
      <b-tab title="Coupon Code">
        <div class="card">
          <div class="card-body">
            <b-row>
              <b-col cols="12" lg="6" md="6" class="mb-1">
                <TextInput
                  v-model="form.couponNumber"
                  type="text"
                  :label="$t('Coupon Code')"
                  :tooltipMessage="$t('Coupon Code')"
                  :required="true"
                  :key="form.couponNumber"
                  :disabled="true"
                />
              </b-col>
              <b-col cols="12" lg="6" md="6" class="mb-1">
                <TextInput
                  v-model="form.createdUser"
                  type="text"
                  :label="$t('creator')"
                  :required="false"
                  :disabled="true"
                />
              </b-col>
              <b-col cols="12" lg="6" md="6" class="mb-1">
                <TextInput
                  v-model="form.startDate"
                  type="date"
                  :label="$t('startDate')"
                  :tooltipMessage="$t('startDate')"
                  :required="true"
                  :key="form.startDate"
                  :disabled="true"
                />
              </b-col>
              <b-col cols="12" lg="6" md="6" class="mb-1">
                <TextInput
                  v-model="form.dueDate"
                  type="date"
                  :label="$t('dueDate')"
                  :tooltipMessage="$t('dueDate')"
                  :required="true"
                  :key="form.dueDate"
                  :disabled="true"
                />
              </b-col>
              <b-col cols="12" lg="6" md="6" class="mb-1">
                <label class="input-label form-label"
                  >{{ $t("type") }}&nbsp;<span style="color: red">*</span>
                </label>
                <b-form-group class="mb-0">
                  <select disabled class="form-control" v-model="form.type">
                    <option
                      v-for="option in typeOptions"
                      :value="option.value"
                      :key="option.value"
                    >
                      {{ $t(option.text) }}
                    </option>
                  </select>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="6" md="6" class="mb-1">
                <TextInput
                  v-model="form.freeUsers"
                  type="number"
                  :disabled="true"
                  :label="
                    $t(form.type === 'coins' ? 'freeCredits' : 'freeCases')
                  "
                  :required="true"
                />
              </b-col>
              <b-col cols="12" lg="6" md="6" class="mb-1">
                <TextInput
                  v-model="form.amountOfActivations"
                  type="number"
                  :disabled="true"
                  label="Amount of activations"
                  :required="true"
                />
              </b-col>
              <b-col cols="12" lg="6" md="6" class="mb-1">
                <div class="form-group mt-1">
                  <label class="input-label form-label" for="cars">{{
                    $t("instantlyGrantCredits/cases")
                  }}</label>

                  <input
                    id="isInstantGrant"
                    disabled
                    class="form-check-input-custom ml-2"
                    v-model="form.isInstantGrant"
                    type="checkbox"
                  />
                </div>
              </b-col>
              <b-col cols="12" lg="12" md="12" class="mb-1">
                <label class="input-label form-label" for="cars">{{
                  $t("notes")
                }}</label>
                <textarea
                  disabled
                  class="form-control"
                  rows="5"
                  v-model="form.notes"
                />
              </b-col>
            </b-row>
          </div>
        </div>
      </b-tab>
      <b-tab title="History" lazy>
        <History />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import TextInput from "@/components/TextInput.vue";
import PageHeader from "@/components/PageHeader.vue";
import MultiSelect from "vue-multiselect";
import History from "./components/History.vue";

export default {
  components: {
    TextInput,
    PageHeader,
    MultiSelect,
    History,
  },
  computed: {
    items() {
      return [
        {
          text: "Dental Twin",
          to: "/home",
        },
        {
          text: this.$t("couponCodes"),
          to: "/coupon-codes",
        },
        {
          text: this.$t("show"),
          active: true,
        },
      ];
    },
  },
  data() {
    return {
      form: {
        startDate: "",
        couponNumber: "",
        dueDate: "",
        freeUsers: "",
        amountOfActivations: "",
        isInstantGrant: false,
        createdBy: "",
        type: "",
        createdUser: "",
        notes: "",
      },
      typeOptions: [
        { value: "coins", text: "credits" },
        { value: "cases", text: "cases" },
      ],
    };
  },
  async mounted() {
    try {
      this.$store.commit("showLoader", true);
      await this.$store
        .dispatch("coupons/show", this.$route.params.id)
        .then(async (res) => {
          var response = res?.data?.data;
          this.form.couponNumber = response?.couponNumber;
          this.form.dueDate = response?.dueDate;
          this.form.startDate = response?.startDate;
          this.form.freeUsers = response?.freeUsers;
          this.form.isInstantGrant = response?.isInstantGrant;
          this.form.amountOfActivations = response?.amountOfActivations;
          this.form.createdBy = response?.createdBy;
          this.form.type = response?.type;
          this.form.notes = response?.notes;
          let responseUser = await this.$store.dispatch("users/show", {
            id: this.form.createdBy,
          });
          this.form.createdUser =
            responseUser?.data?.first_name +
            " " +
            responseUser?.data?.last_name;
        });
    } catch (e) {
      console.error("api error ___", e);
    } finally {
      this.$store.commit("showLoader", false);
    }
  },
};
</script>

<style scoped>
#nprogress {
  position: relative;
  z-index: 9999999;
}

.white-color {
  color: white !important;
}

.vgt-responsive {
  overflow-x: visible !important;
}
</style>
